import FullScreenModal from "../../../components/common/modalPopup/FullScreenModal";
import { Box } from "@mui/material";
import MuiTabs, { TabsDetails } from "../../../components/common/tabs/MuiTabs";
import FdpGeneralDetails from "../FdpGeneralDetails";
import FdpUsers from "../FdpUsers";
import { useEffect, useRef, useState } from "react";
import { RootState, useAppDispatch } from "../../../app/features/store/store";
import {
  clearFdpUserList,
  updateFdpAssociatedClients,
} from "../../../app/features/fdp/fdpSlice";
import { FdpResponse } from "../../../app/models/responseModels/loginResponse";
import FdpHistory from "../FdpHistory";
import FdpInvoiceList from "../invoices/FdpInvoiceList";
import { useSelector } from "react-redux";

interface FdpDetailsModalProps {
  closeFdpDetailsModal: CallableFunction;
  onCompleted: CallableFunction;
  fdpRowData: FdpResponse;
}

const FdpDetailsModal = ({
  closeFdpDetailsModal,
  fdpRowData,
  onCompleted,
}: FdpDetailsModalProps) => {
  const dispatch = useAppDispatch();

  const [fdpSelectedRow, setFdpSelectedRow] = useState<FdpResponse>(fdpRowData);
  const prevFdpSelectedRow = useRef<FdpResponse>(fdpSelectedRow);
  const [isFdpUpdated, setFdpUpdated] = useState<boolean>(false);

  const userDetails = useSelector(
    (state: RootState) => state.login?.authResponse?.userSettings
  );

  useEffect(() => {
    if (fdpSelectedRow !== prevFdpSelectedRow.current) {
      setFdpUpdated(true);
    }
  }, [fdpSelectedRow]);

  useEffect(() => {
    return () => {
      dispatch(clearFdpUserList([]));
      dispatch(updateFdpAssociatedClients([]));
      if (isFdpUpdated) {
        onCompleted();
      }
    };
  }, [dispatch, onCompleted]);

  const tabsValues: TabsDetails[] = [
    ...(userDetails?.roles.includes("Administrators")
      ? [
          {
            tabName: "General",
            tabContent: (
              <FdpGeneralDetails
                fdpSelectedRow={fdpSelectedRow}
                setFdpSelectedRow={setFdpSelectedRow}
              />
            ),
            index: 0,
          },
          {
            tabName: "Users",
            tabContent: <FdpUsers fdpRowData={fdpSelectedRow} />,
            index: 1,
          },
          {
            tabName: "History",
            tabContent: (
              <FdpHistory
                fdpSelectedRow={fdpSelectedRow}
                setFdpSelectedRow={setFdpSelectedRow}
              />
            ),
            index: 2,
          },
        ]
      : []),
    {
      tabName: "Invoice (s)",
      tabContent: (
        <FdpInvoiceList
          FdpId={fdpRowData?.id}
          companyName={fdpRowData?.companyName}
        />
      ),
      index: userDetails?.roles.includes("Administrators") ? 3 : 0,
    },
  ];

  const handleSubmit = async () => {
    return true;
  };

  return (
    <>
      <FullScreenModal
        title="Fdp Details"
        updateAsyncOperation={handleSubmit}
        closeFullScreenModal={closeFdpDetailsModal}
        isLoading={false}
        closeModalAfterSubmit={true}
        confirmMessage="Are you sure you want to delete?"
        isUpdatePermission={true}
        isDeletePermission={false}
        showSubmitButton={false}
        showDeleteButton={false}
      >
        <Box>
          <MuiTabs tabDetails={tabsValues} />
        </Box>
      </FullScreenModal>
    </>
  );
};

export default FdpDetailsModal;
